package fr.frux.core.designsystem.components

import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Snackbar
import androidx.compose.material3.SnackbarData
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp

/**
 * Snackbar de l'app : fond inversé, action en `inversePrimary` sur une cible de 48 dp.
 * Les messages « Voir » ou « Réessayer » de l'assistant passent par `SnackbarHostState.showSnackbar`.
 */
@Composable
fun FruxSnackbar(
    data: SnackbarData,
    modifier: Modifier = Modifier,
) {
    val visuals = data.visuals
    val scheme = MaterialTheme.colorScheme
    Snackbar(
        modifier = modifier.padding(start = 12.dp, end = 12.dp, bottom = 24.dp).heightIn(min = 48.dp),
        shape = RoundedCornerShape(12.dp),
        containerColor = scheme.inverseSurface,
        contentColor = scheme.inverseOnSurface,
        action =
            visuals.actionLabel?.let { label ->
                {
                    TextButton(
                        onClick = { data.performAction() },
                        modifier = Modifier.heightIn(min = FruxMinTouchTarget),
                        colors = ButtonDefaults.textButtonColors(contentColor = scheme.inversePrimary),
                    ) {
                        Text(text = label, style = MaterialTheme.typography.labelLarge)
                    }
                }
            },
        dismissAction = null,
    ) {
        Text(text = visuals.message, style = MaterialTheme.typography.bodyMedium)
    }
}
